<div class="bg-th-yellow mt-0 container-fluid">
  <div class="d-flex justify-content-between align-content-center h-35">
    <i
      class="fa fa-arrow-left text-dark my-auto pointer"
      (click)="goBack()"
    ></i>

    <span class="my-auto f16 fw-bold me-2"> داشبورد تانکرها </span>
  </div>
</div>

<div class="container p-3 border my-3">
  <div class="row gx-3 gy-3">
    <div class="col-12 col-md-6">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2">
            حجم موجودی به تفکیک نوع ماده
          </p>

          <canvas
            id="myChart1"
            style="height: 372px !important; max-height: 372px !important"
          ></canvas>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="bg-gray border bg-light">
        <div>
          <p class="text-center f18 text-center bg-smoke p-2">
            گیچ وضعیت مخزن تانکرها
          </p>

          <canvas id="myChart" class="w-100"></canvas>

          <p class="d-flex justify-content-between p-2">
            <small> مقدار ظرفیت پر : {{ currentValue | faNum }} </small>
            <small> مقدار حداکثر ظرفیت : {{ maxCapacity | faNum }} </small>
          </p>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2">
            موجودی تانکر ها
          </p>

          <canvas id="myChart2" style="max-height: 350px !important"></canvas>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2">
            تعداد تانکر به تفکیک ظرفیت
          </p>

          <canvas id="myChart3" style="max-height: 350px !important"></canvas>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2">
            تعداد تغذیه به تفکیک محل تامین
          </p>

          <canvas id="myChart4" style="max-height: 350px !important"></canvas>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2">
            تغذیه به تفکیک ساعات شبانه روز
          </p>

          <canvas id="myChart5" style="max-height: 350px !important"></canvas>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2">
            تخلیه به تفکیک ساعات شبانه روز
          </p>

          <canvas id="myChart6" style="max-height: 350px !important"></canvas>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart2">
          <p class="f18 text-center bg-smoke p-2 mb-0">
            نقشه پراکندگی تغذیه‌های مجاز
          </p>
          <div id="map3" class="fixed-mapCluster">
            <div class="position-absolute"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" dir="rtl">
      <div class="bg-gray border chart-wrapper">
        <p class="py-3 mb-0 text-center text-white">روند تخلف در 30 روز گذشته</p>
        <!--  -->
        <div class="chart-box">
          <canvas id="violationTrendesChart"></canvas>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart4">
          <p class="f18 text-center bg-smoke p-2 mb-0">
            نقشه پراکندگی تغذیه‌های غیرمجاز
          </p>
          <div id="map4" class="fixed-mapCluster">
            <div class="position-absolute"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="f18 text-center bg-smoke p-2 mb-0">نقشه پراکندگی تخلیه</p>
          <div id="map1" class="fixed-mapCluster">
            <div
              class="position-absolute"
              id="map_tooltip"
              data-bs-html="true"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="bg-gray border bg-light">
        <div id="chart1">
          <p class="text-center f18 text-center bg-smoke p-2 mb-0">
            نقشه وضعیت خودروها ( براساس موجودی )
          </p>

          <div class="row gx-2 w-100 text-center p-2">
            <div
              class="d-flex flex-column flex-md-row align-items-center justify-content-around col bg-green-dark p-2"
            >
              <img src="../../../../assets/Img/greenBus.png" alt="" />

              <span>
                <small> {{ "بیش از 70 از ظرفیت آن پر است" | faNum }} </small>
              </span>
            </div>

            <div
              class="d-flex flex-column flex-md-row align-items-center justify-content-around col text-center bg-blue-light p-2"
            >
              <img src="../../../../assets/Img/blueBus.png" alt="" />

              <span>
                <small>{{ "بین 50 تا 70 درصد ظرفیت آن پر است" | faNum }}</small>
              </span>
            </div>

            <div
              class="d-flex flex-column flex-md-row align-items-center justify-content-around col bg-th-yellow p-2"
            >
              <img src="../../../../assets/Img/orangeBus.png" alt="" />

              <span>
                <small>{{ "بین 20 تا 50 درصد ظرفیت آن پر است" | faNum }}</small>
              </span>
            </div>

            <div
              class="d-flex flex-column flex-md-row align-items-center justify-content-around col bg-pink p-2"
            >
              <img src="../../../../assets/Img/redBus.png" alt="" />

              <span class="">
                <small>{{
                  "کمتر از 20 درصد از حجم آن خالی است" | faNum
                }}</small>
              </span>
            </div>
          </div>

          <div id="map2" class="fixed-mapCluster">
            <div
              class="position-absolute"
              id="map_tooltip"
              data-bs-html="true"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" dir="rtl">
      <div class="bg-gray border bg-light">
        <p class="py-3 mb-0 text-center">لیست تانکر های پرخطر</p>
        <div
          class="section border mt-2"
          style="height: 500px; overflow: hidden"
        >
          <table class="col-12 table table-striped rounded-3" id="Export_Excel">
            <thead>
              <tr class="text-center">
                <th scope="col">#</th>
                <th scope="col">رتبه</th>
                <th scope="col">تانکر</th>
                <th scope="col">پلاک</th>
                <th scope="col">موبایل</th>
                <th scope="col">شاخص اعتماد</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="f14 text-center"
                *ngFor="let item of highRiskDrivers; let i = index"
              >
                <th class="text-dark">{{ i + 1 | faNum }}</th>
                <td>{{ item.Rank }}</td>
                <td>{{ item.strFullName }}</td>
                <td>{{ item.strVehicleNo }}</td>
                <td>{{ item.strMobile | faNum }}</td>
                <td>{{ item.ComplianceScore | faNum }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="detailModal"
  style="z-index: 100000000000000"
  tabindex="-1"
  aria-labelledby=""
  data-backdrop="false"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content p-1">
      <div class="modal-header dirI">
        <h5 class="modal-title">جزئیات تانکر</h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div dir="rtl" class="x row p-2 gx-2 gy-2">
        <div class="col-12 col-md-6">
          <label> نام و نام خانوادگی </label>

          <input
            type="text"
            [ngModel]="tankerData?.strFullName"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> موبایل </label>

          <input
            type="text"
            [ngModel]="tankerData?.strMobile | faNum"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> تاریخ </label>

          <input
            type="text"
            [ngModel]="tankerData?.strDate | faNum"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> ساعت شروع </label>

          <input
            type="text"
            [ngModel]="tankerData?.strSTime | faNum"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> ساعت پایان </label>

          <input
            type="text"
            [ngModel]="tankerData?.strETime | faNum"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> نوع </label>

          <input
            type="text"
            [ngModel]="tankerData?.strGPSType_strComment"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> پلاک </label>

          <input
            type="text"
            [ngModel]="formatted_pelak(tankerData?.strVehicleNo | faNum)"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> ظرفیت </label>

          <input
            type="text"
            [ngModel]="tankerData?.fCapacity | faNum"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> حجم تخلیه </label>

          <input
            type="text"
            [ngModel]="tankerData?.fDischargeValue | faNum"
            class="form-control"
          />
        </div>

        <div class="col-12 col-md-6">
          <label> حوزه خدمت </label>

          <input
            type="text"
            [ngModel]="tankerData?.strMobileDomain_strComment"
            class="form-control"
          />
        </div>
      </div>
    </div>
  </div>
</div>
